export function formatFileSize(bytes: number | undefined | null): string {
  if (!bytes || bytes <= 0) return '';
  if (bytes < 1024) return `${bytes} B`;
  if (bytes < 1024 * 1024) return `${(bytes / 1024).toFixed(0)} KB`;
  return `${(bytes / (1024 * 1024)).toFixed(1)} MB`;
}

export function readingLabel(minutes: number): string {
  return minutes === 1 ? '1 minuut lezen' : `${minutes} minuten lezen`;
}

const IMG_EXT = /\.(png|jpe?g|gif|webp|svg|bmp|ico)$/i;
const VIDEO_EXT = /\.(mp4|webm|ogg|mov)$/i;

export const isImageFile = (name: string) => IMG_EXT.test(name);
export const isVideoFile = (name: string) => VIDEO_EXT.test(name);
